import React from "react";
import "./PrivacyPolicy.css"; // Add styles for this page

const PrivacyPolicy = () => {
    return (
        <div className="privacy-policy">
            <div className="container">
                <h1>Privacy Policy for EasyDreams</h1>
                <p><strong>Last Updated:</strong> January 27, 2025</p>
                <p>
                    This Privacy Policy applies to the EasyDreams app (hereinafter referred to as "Application")
                    created by <strong>Vitalii Trypuz</strong> (hereinafter referred to as "Service Provider").
                    The Application is offered as a free service, and by using the Application, you agree to the
                    collection and use of information in accordance with this policy.
                </p>

                <h2>Information Collection and Use</h2>
                <p>
                    The Application may collect and use the following types of data:
                </p>
                <ul>
                    <li><strong>Device Data:</strong> Includes information such as the device's Internet Protocol (IP) address, operating system, and device type.</li>
                    <li><strong>App Usage Data:</strong> Includes the pages or features accessed within the Application, the duration of use, and other related analytics.</li>
                    <li><strong>Advertisements:</strong> The Application contains ads provided by <strong>AdMob</strong>, which may collect non-personal data to serve targeted ads. Refer to <a href="https://support.google.com/admob/answer/6128543?hl=en" target="_blank" rel="noopener noreferrer">AdMob Privacy Policy</a> for more details.</li>
                </ul>
                <p>
                    The Service Provider uses this data to:
                </p>
                <ul>
                    <li>Improve the functionality and performance of the Application.</li>
                    <li>Provide personalized user experiences.</li>
                    <li>Analyze trends and gather user behavior insights.</li>
                </ul>

                <h2>Third-Party Services</h2>
                <p>
                    The Application uses third-party services for ads and analytics, which may collect information used to identify you. The following services are integrated into the Application:
                </p>
                <ul>
                    <li><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google Play Services</a></li>
                    <li><a href="https://support.google.com/admob/answer/6128543?hl=en" target="_blank" rel="noopener noreferrer">AdMob</a></li>
                </ul>

                <h2>Data Retention</h2>
                <p>
                    The Service Provider retains the collected data for as long as it is necessary to provide the services and improve the Application. If you wish to have your data removed, please contact us at <a href="mailto:tripuz99@gmail.com">tripuz99@gmail.com</a>.
                </p>

                <h2>Children's Privacy</h2>
                <p>
                    The Application is not directed toward individuals under the age of 13. The Service Provider does not knowingly collect personal information from children under 13. If such information is discovered, it will be deleted immediately. Parents or guardians who believe their child has provided personal data should contact us at <a href="mailto:tripuz99@gmail.com">tripuz99@gmail.com</a>.
                </p>

                <h2>Security of Your Information</h2>
                <p>
                    The Service Provider is committed to protecting the security of your data. While no system can guarantee absolute security, industry-standard measures are in place to safeguard your data.
                </p>

                <h2>Changes to This Privacy Policy</h2>
                <p>
                    The Privacy Policy may be updated periodically. Any changes will be posted on this page. Users are encouraged to review the policy regularly. Continued use of the Application after any updates constitutes acceptance of the revised Privacy Policy.
                </p>

                <h2>Contact Us</h2>
                <p>
                    If you have questions or concerns regarding this Privacy Policy, please contact:
                </p>
                <ul>
                    <li><strong>Vitalii Trypuz</strong></li>
                    <li>Email: <a href="mailto:tripuz99@gmail.com">tripuz99@gmail.com</a></li>
                </ul>
            </div>
        </div>
    );
};

export default PrivacyPolicy;